import { useState, useEffect } from "react";
export const SIZES = {
	xs: 420,
	sm: 640,
	md: 768,
	"2md": 900,
	lg: 1024,
	xl: 1280,
	"2xl": 1400,
};

export interface ScreenSize {
	width: number;
	height: number;
	xs: boolean; // 420px
	sm: boolean; // 640px
	md: boolean; // 768px
	"2md": boolean; // 900px
	lg: boolean; // 1024px
	xl: boolean; // 1280px
	"2xl": boolean; // 1400px
}
export const useScreenSize = () => {
	const [size, setSize] = useState<ScreenSize>({
		width: window.innerWidth,
		height: window.innerHeight,
		xs: window.innerWidth >= SIZES.xs,
		sm: window.innerWidth >= SIZES.sm,
		md: window.innerWidth >= SIZES.md,
		"2md": window.innerWidth >= SIZES["2md"],
		lg: window.innerWidth >= SIZES.lg,
		xl: window.innerWidth >= SIZES.xl,
		"2xl": window.innerWidth >= SIZES["2xl"],
	});

	useEffect(() => {
		window.onresize = () => {
			setSize({
				width: window.innerWidth,
				height: window.innerHeight,
				xs: window.innerWidth >= SIZES.xs,
				sm: window.innerWidth >= SIZES.sm,
				md: window.innerWidth >= SIZES.md,
				"2md": window.innerWidth >= SIZES["2md"],
				lg: window.innerWidth >= SIZES.lg,
				xl: window.innerWidth >= SIZES.xl,
				"2xl": window.innerWidth >= SIZES["2xl"],
			});
		};

		// For initial calibartion
		dispatchEvent(new Event("resize"));
	}, []);

	return { size };
};
